import React from 'react';
import { useSiteContent } from '../contexts/SiteContentContext';
import { FadeLink, Markup, Section, useCopy } from './core';
import productLearn from './svg/productLearn';
import productNexus from './svg/productNexus';
import productOne from './svg/productOne';

const copy = {
  en: {
    eyebrow: 'Our products', title: 'Meet our product family.', portfolio: 'Explore the portfolio', more: 'Learn more',
    status: { available: 'Available', beta: 'Beta', 'coming-soon': 'Coming soon' },
    products: {
      learn: ['Learning · Teaching · Research', 'An AI workspace for learning, teaching and research, with people in control.', 'University students, faculty, researchers and institutional teams.'],
      nexus: ['AI team setup', 'Describe the AI team you need.', 'AI-team setup and management.'],
      'agentec-one': ['Personal desktop workspace', 'One workspace for your everyday AI work.', 'Individuals and professional users.']
    }
  },
  zh: {
    eyebrow: '我们的产品', title: '认识我们的产品家族。', portfolio: '查看全部产品', more: '了解更多',
    status: { available: '已上线', beta: '测试版', 'coming-soon': '即将推出' },
    products: {
      learn: ['学习 · 教学 · 科研', '面向学习、教学与科研的 AI 工作空间，关键决定由人掌握。', '高校学生、教师、研究人员及院校团队。'],
      nexus: ['AI 团队搭建', '用对话描述您需要的 AI 团队。', 'AI 团队搭建与管理。'],
      'agentec-one': ['个人桌面工作台', '一个工作台，承载您日常的 AI 工作。', '个人用户与专业工作者。']
    }
  }
};

export const PRODUCTS = [
  { slug: 'learn', anchor: 'p-learn', name: 'Agentec Learn', svg: productLearn },
  { slug: 'nexus', anchor: 'p-nexus', name: 'Agentec Nexus', svg: productNexus },
  { slug: 'agentec-one', anchor: 'p-one', name: 'Agentec One', svg: productOne }
];

export function useProductStatus() {
  const { products } = useSiteContent();
  const { t } = useCopy(copy);
  return (slug) => t.status[products.find((product) => product.slug === slug)?.status || 'available'];
}

export default function ProductFamily({ portfolioTo = '/products', anchors = false, homeThreshold }) {
  const { t } = useCopy(copy);
  const status = useProductStatus();
  const sectionProps = homeThreshold ? { threshold: 0.22, rootMargin: '0px' } : { threshold: 0.2, rootMargin: '0px' };
  return <Section className="products" id="products" {...sectionProps}>
    <div className="wrap">
      <div className="center-head" data-reveal="">
        <p className="eyebrow">{t.eyebrow}</p>
        <h2>{t.title}</h2>
        <FadeLink className="link" to={portfolioTo}>{t.portfolio} <span className="ar" aria-hidden="true">↗</span></FadeLink>
      </div>
      <div className="pcards">
        {PRODUCTS.map((product, index) => {
          const [kicker, description, audience] = t.products[product.slug];
          return <FadeLink key={product.slug} className="pcard" id={anchors ? product.anchor : undefined} to={`/products/${product.slug}`} data-reveal="" style={{ '--i': index + 1 }}>
            <span className="k">{kicker}</span>
            <span className="t"><h3>{product.name}</h3><span className="status">{status(product.slug)}</span></span>
            <Markup className="v dots" markup={product.svg} />
            <span className="d">{description}</span><hr />
            <span className="a">{audience}</span>
            <span className="link">{t.more} <span className="ar" aria-hidden="true">↗</span></span>
          </FadeLink>;
        })}
      </div>
    </div>
  </Section>;
}
